import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  show(event) {
    const tooltip = event.currentTarget.nextElementSibling
    if (tooltip) {
      tooltip.classList.remove("hidden")
    }
  }

  hide(event) {
    const tooltip = event.currentTarget.nextElementSibling
    if (tooltip) {
      tooltip.classList.add("hidden")
    }
  }
}